import { useEffect, useMemo } from 'react';
import { type Token } from '@/shared/assets/tokens';
import { useCoinGeckoPrices } from '@/shared/hooks/useCoinGeckoPrices';

const useTokenPrice = (token: Token | undefined) => {
  const { watchTokens, getPrice, isLoading } = useCoinGeckoPrices();

  const tokens = useMemo(() => (token ? [token] : []), [token?.chain.id, token?.address]);
  useEffect(() => watchTokens(tokens), [tokens]);

  return {
    isLoading,
    price: token && getPrice(token),
  };
};

export default useTokenPrice;
